export default __webpack_public_path__ + "static/media/settingEdit.1528af2e.svg";